// src/cert/rohs.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const RoHS = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>RoHS अनुपालन</h1>
                <p>हानिकारक पदार्थ प्रतिबंध निर्देश (Restriction of Hazardous Substances)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>RoHS म्हणजे काय?</h2>
                    <p>
                        ROHS(Restriction of Hazardous Substance) Since the early 21st Century, electronic waste and chemicals use have become more common, like luminescence of radium or the low melting point of 60/40 lead-tin alloy. But about its harmful effects, no one was aware, how its unnecessary exposure was dangerous to human health as well as the environment. As a result, hundreds of thousands of people have developed health problems such as lung cancer, mesothelioma, and asbestosis. The use of hazardous substances gave birth to the Restriction of Hazardous Substance (RoHS) in February 2003 by European Union.

                        The RoHS directive took effect on 1 July 2006 and was required to be enforced and become law in each member state. RoHS restricted the use of certain hazardous substances in electrical and electronic equipment. Their major motive behind this step is to reduce the use of harmful substances and reduce the environmental effect and health impacts of electronics.

                        RoHS stands for Restriction of Hazardous Substances, which is also known as the Directive 2002/95/EC. It includes the restrictions for the use of certain hazardous substances in electrical and electronic equipment. RoHS is a WEEE (Waste of Electrical and Electronic Equipment).

                        In India, demand for electronic products is increasing widely, due to which the environment and human health are in danger. Furthermore, rapidly evolving technologies encourage consumers to discard electronic devices quickly, resulting in an alarming increase in the amount of electronic trash. Keeping this in consideration all the harmful effects of electronic waste, The Ministry of Environment and Forest (MoEF) and the Government of India implemented the Restriction of Hazardous Substance, which in India is known as Electronic waste.

                        Depending on the size of the Indian legal entity and the type of imported devices, you may be subject to WEEE or RoHS responsibilities if you produce or import electronic products in the Republic of India.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>EU मध्ये इलेक्ट्रॉनिक उत्पादन विक्री कायदेशीर होते</li>
                        <li>मानवी आरोग्य आणि पर्यावरण संरक्षण</li>
                        <li>उत्पादन परतावा, दंड आणि बाजारातून काढून टाकण्यापासून वाचतो</li>
                        <li>सामग्री विश्लेषण (XRF), DoC, तकनीकी दस्तऐवज अनिवार्य</li>
                        <li>CE Marking सोबत सुसंगतता</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>RoHS अनुपालनासाठी अर्ज करा</h2>
                    <ApplyForm certification="RoHS" />
                </section>
            </div>
        </div>
    );
};

export default RoHS;